import {disableReactDevTools} from '@fvilers/disable-react-devtools';
import {REACT_APP_NODE_ENV} from "./constants/env";
import './lang';
import {ScrollProvider} from "./components/Scroll/Scroll";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import BackTop from "./pages/components/BackTop/BackTop";
import LanguageButton from "./pages/components/Lan/LanguageButton";
import HomePage from "./pages/Home/HomePage";
import {getUserByToken} from "./store/slices/userSlice";
import FullLoading from "./components/LoadingComponents/FullLoading";

if (REACT_APP_NODE_ENV === 'production') {
    disableReactDevTools();
}

function App() {
    return (
        <ScrollProvider>
            <BackTop/>
            <LanguageButton/>
            <Router>
                <Routes>
                    <Route path='/' element={<HomePage/>}/>
                </Routes>
            </Router>
        </ScrollProvider>
    );
}

export default App;
